<div class="error-page">
  <div class="error-content">
    <!-- Illustration -->
    <div class="illustration">
      <svg class="illustration-svg" width="220" height="220" viewBox="0 0 220 220" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- Outer dashed circle (slow rotate) -->
        <circle class="ring-outer" cx="110" cy="110" r="105" stroke="hsl(var(--destructive) / 0.15)" stroke-width="1" stroke-dasharray="6 4" fill="none" />
        <!-- Middle dashed circle (slow rotate reverse) -->
        <circle class="ring-middle" cx="110" cy="110" r="85" stroke="hsl(var(--destructive) / 0.12)" stroke-width="1" stroke-dasharray="4 4" fill="none" />
        <!-- Inner solid circle (pulse) -->
        <circle class="ring-inner" cx="110" cy="110" r="65" fill="hsl(var(--destructive) / 0.06)" />
        <!-- Accent dot on outer ring -->
        <circle class="accent-dot" cx="148" cy="18" r="5" fill="hsl(var(--destructive) / 0.2)" />

        <!-- Shield icon -->
        <path d="M110 68c-18 0-33 6-33 6v38c0 20 14 35 33 42 19-7 33-22 33-42V74s-15-6-33-6z"
              stroke="hsl(var(--destructive))" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
        <!-- Diagonal line through shield -->
        <line x1="92" y1="96" x2="128" y2="118" stroke="hsl(var(--destructive))" stroke-width="2.5" stroke-linecap="round" />

        <!-- Lock badge -->
        <circle cx="138" cy="140" r="14" fill="hsl(var(--destructive))" />
        <rect x="132" y="139" width="12" height="9" rx="2" fill="hsl(var(--card))" />
        <path d="M135 139v-3a3 3 0 0 1 6 0v3" stroke="hsl(var(--card))" stroke-width="1.5" fill="none" stroke-linecap="round" />
      </svg>
    </div>

    <!-- Error badge -->
    <div class="error-badge error-badge--destructive">
      {{ 'login_component.forbidden_badge' | translate }}
    </div>

    <!-- Title -->
    <h1 class="error-title">
      {{ 'login_component.forbidden_title' | translate }}
    </h1>

    <!-- Description -->
    <p class="error-description">
      {{ 'login_component.forbidden_desc' | translate }}
    </p>

    <!-- Back button -->
    <app-calio-flat-button
      type="primary"
      size="lg"
      enableRoutingHyperLink
      url="/"
      icon="arrow-left"
      buttonText="{{ 'login_component.back_to_dashboard' | translate }}"
    />
  </div>
</div>
